const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { Promise } = require('es6-promise');
const { APIPost } = require('utilities/APIRequestHelper');
const signaturePatternActions = require('actions/signaturePattern');
const DateHelper = require('utilities/dateHelper');
const { nonNumericFilter } = require('utilities/stringHelper');

const resetCvv = (cardId) => ({
    type: actionTypes.CARD_CVV_RESET,
    payload: {
        cardId
    }
});

const setExpired = (cardId) => ({
    type: actionTypes.SET_CARD_CVV_EXPIRED,
    payload: {
        cardId
    }
});

const requestCardsCvv = (cardId) => ({
    type: actionTypes.FETCH_CARD_CVV_REQUEST,
    payload: {
        cardId
    }
});

const requestCardsCvvSuccess = (data, cardId) => ({
    type: actionTypes.FETCH_CARD_CVV_SUCCESS,
    payload: {
        cardId,
        code: data.cvv
    }
});

const requestCardsCvvFailure = (error, cardId) => ({
    type: actionTypes.FETCH_CARD_CVV_FAILURE,
    payload: {
        cardId,
        error
    }
});

const requestCvv = (cardId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {

        const immCard = getState().cards.get('byId').get(cardId);
        const numTarjeta = nonNumericFilter(immCard.get('number'));
        const fechaCaducidad = DateHelper.buildFormattedDate(immCard.get('expirationDate'), 'MMYY');

        const requestData = {
            query: {
                dataToken,
                fechaCaducidad,
                numTarjeta
            }
        };

        dispatch(requestCardsCvv(cardId));
        APIPost(dispatch, apiURLBuilder.getURL('cardCvvRequest') , requestData).then(
            response => dispatch(requestCardsCvvSuccess(response, cardId)),
            response => dispatch(requestCardsCvvFailure(response, cardId))
        );
    }

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    resetCvv,
    setExpired,
    requestCvv
}
